"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupDirectDebitConfirm = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var ui_1 = require("./ui");
exports.SetupDirectDebitConfirm = (0, core_1.withCustomerAndAccountIds)(function () {
    var _a;
    return (react_1.default.createElement(ui_tools_1.AnalyticsPage, { name: analytics_subjects_1.SETUP_DD_SUCCESS, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
        react_1.default.createElement(ui_1.SetupDirectDebitConfirmUI, null)));
});
